"use client";

import { cn } from "@/lib/utils";
import { FaucetForm } from "./_components/Faucet/FaucetForm";
import { FaucetStatistics } from "./_components/Statistics";
import { AboutFaucet } from "./_components/AboutFaucet";
import { RecentActivity } from "./_components/RecentActivity";
import { Resources } from "./_components/Resources";

export default function Home() {
  return (
    <div className="flex items-center justify-center py-5">
      <div
        className={cn(
          "max-w-8xl w-full",
          "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5"
        )}
      >
        <div className="xl:col-span-2 flex flex-col gap-5">
          <FaucetForm />
          <AboutFaucet />
          <RecentActivity />
        </div>
        <div className="flex flex-col gap-5">
          <FaucetStatistics />
          <Resources />
        </div>
      </div>
    </div>
  );
}
